import { toast } from "react-toastify";
import { useResetTwoFactorMutation } from "../../store/services/UsersService"
import Loader from "../main/Loader";
import { useDispatch } from "react-redux";
import { setIsOpenDialogAction } from "../../store/feautures/DialogActionSlice";

export default function ManageTwoFactor({ row }: any) {

    const [resetTwoFactor, { isLoading }] = useResetTwoFactorMutation();
    const dispatch = useDispatch();

    const handleConfirm = async () => {
        try {
            await resetTwoFactor({ userId: String(row?.id) }).unwrap();
            toast.success(`Autenticazione con codice resettata`);
            dispatch(setIsOpenDialogAction({isOpen: false}));
        } catch (err: any) {
            const detail = err?.data?.detail || "Errore sconosciuto";
            toast.error(`Autenticazione con codice non resettata! ${detail}`);
        }
    };

    return (
        <div className="p-10 h-full flex flex-col justify-between">

            { isLoading && <Loader /> }

            <p className="flex-1 gap-y-6">
                Vuoi resettare l'autenticazione a due fattori per l'utente {row?.nome} {row?.cognome}?
                Questo permetterà all'utente, al prossimo accesso, di visualizzare nuovamente il QR code per configurare
                l'autenticazione sul proprio dispositivo.
            </p>

            <div className="flex justify-end my-10">
                <button onClick={handleConfirm} type="button" className="h-10 bg-[#064e3b] text-white px-2 inline rounded-lg text-md">
                    Conferma
                </button>
            </div>
        </div>
    )
}